import React from "react";
import QuickOnlineHeader from "./QuickOnlineHeader";
import "./index.css";
import { Stack } from "react-bootstrap";
const QuickReportPagesLayout = ({ children }) => {
  // useEffect(() => {
  //   const handleResize = () => {
  //     setIsMobile(window.innerWidth <= 768);
  //   };

  //   window.addEventListener("resize", handleResize);

  //   return () => {
  //     window.removeEventListener("resize", handleResize);
  //   };
  // }, []);
  return (
    <div className="quicklayoutwrapper d-flex flex-column">
      <div className="header-report">
        <div
          className="container"
          style={{ backgroundColor: "#359742", paddingBottom: "30px" }}
        >
          <QuickOnlineHeader />
        </div>
      </div>
      <Stack
        className="maincontent container gx-0 flex-grow-1 open-sans-font"
        style={{
          borderRadius: "20px 20px 0px 0px",
          marginTop: "-15px",
          background: "#fff",
          position: "relative",
          zIndex: "1",
          maxWidth: "767px",
        }}
      >
        {/* {isMobile ? ( */}
        <Stack className="mobileaccess flex-grow-1"> {children}</Stack>
        {/* ) : (
          <h3 className="vh-50 justify-content-center d-flex align-items-center">
              You can access this page on mobile device only!
          </h3>
        )}  */}
      </Stack>
    </div>
  );
};

export default QuickReportPagesLayout;
